"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ADMIN_COMPANY_STORE_CATEGORIES = void 0;
var client_1 = require("@apollo/client");
exports.GET_ADMIN_COMPANY_STORE_CATEGORIES = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nquery GetAdminCompanyStoreCategoriesById($input: CompanyStoresByIdsInput!) {\n    companyStoresByIds(input: $input) {\n      category\n      id\n    }\n  }\n"], ["\nquery GetAdminCompanyStoreCategoriesById($input: CompanyStoresByIdsInput!) {\n    companyStoresByIds(input: $input) {\n      category\n      id\n    }\n  }\n"])));
var templateObject_1;
